module.exports = __webpack_public_path__ + "static/media/channelimgone.547c5234.png";